<!--
@Time : 2020/12/24 11:37 上午
@Author : yekong
@File : left.vue
@Software : PhpStorm
-->
<template>
  <div class="bodyright">
    <div class="x1" style="height: 25%">
      <item title="车辆出场TOP5">
        <top5></top5>
      </item>
    </div>
    <div class="x1" style="height: 30%">
      <item title="车辆进场TOP5">
        <intop5></intop5>
      </item>
    </div>
    <div class="x1" style="height: 30%">
      <item title="车辆进出高峰时间">
        <times></times>
      </item>
    </div>
  </div>
</template>

<script>
import item from "_c/home/item";
import top5 from "_c/home/left/outtop5";
import times from "_c/home/left/time";
import intop5 from "_c/home/left/intop5";

export default {
  name: "left",
  components: {item, top5, times, intop5},
  data: function () {
    return {
      show: true
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  mounted() {

  },
  filters: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.x1 {
  position: relative;
  width: 100%;
  margin-top: 3.5%;
}

.bodyright {
  width: 27.6%;
  position: absolute;
  height: calc(100% - 1rem - 1.6%);
  right: 1.04%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;

}
</style>
